import { foundationUserApi, useAppSelector } from "@litres-core/store";

/* ВНИМАНИЕ Копия хука находится в NextJS apps/next-app/src/hooks/useGetUserMonetizationData.ts */

export const useGetUserMonetizationData = () => {
  const isUserAuthorized = useAppSelector(state => !!state.foundationUser.id);

  return foundationUserApi.useGetMonetizationDetailsQuery(undefined, {
    skip: !isUserAuthorized,
  });
};
